import { render } from "./farmasi.vue?vue&type=template&id=68860818&scoped=true"
import script from "./farmasi.vue?vue&type=script&lang=js"
export * from "./farmasi.vue?vue&type=script&lang=js"

import "./farmasi.vue?vue&type=style&index=0&id=68860818&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Pulih_Anita/frontend-pulih/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68860818"]])

export default __exports__